import { ChangeDetectorRef, Directive, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

/*** this directive clears only value, and it can able to trigger valuechange event. It never clears ngModel data. */
@Directive({
    selector: '[date-picker-input-clear-button]',
    standalone: false
})
export class DatePickerClearDirective implements OnInit, OnDestroy {
  private button!: HTMLElement;

  private clickHandler = () => {
    this.component.value = <any>"";
    this.component.valueChange.emit(<any>"");
    this.cdr.markForCheck();
    console.log(this.component.value, this.component.dateInput.value);
  }

  constructor(private component: DatePickerComponent, private cdr: ChangeDetectorRef) { }
  public ngOnInit(): void {

    this.button = document.createElement('span');
    this.button.className = 'clear-input-button';
    this.button.innerHTML = "&times;";
    this.button.style.alignSelf = 'center';
    this.button.style.position = 'absolute';
    this.button.style.padding = "5px";
    this.button.style.right = '30px';
    this.button.style.width = '18px';
    this.button.style.height = '100%';
    this.button.style.right = '30px';
    this.button.style.cursor = 'pointer';
    this.button.style.zIndex = '1';
    this.button.style.fontSize = '36px';
    this.button.style.display = 'flex';
    this.button.style.alignItems = 'center';
    this.button.style.justifyContent = 'center';

    this.button.addEventListener('click', this.clickHandler);
    this.component.wrapper.nativeElement.appendChild(this.button);
  }

  public ngOnDestroy(): void {
    this.button.removeEventListener('click', this.clickHandler);
  }
}
